import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import axios from 'axios';

var AuthInterceptor = /*#__PURE__*/function () {
  function AuthInterceptor(store, unauthenticatedAction, authenticatedSelector, cancelledSelector) {
    _classCallCheck(this, AuthInterceptor);

    this.store = store;
    this.unauthenticatedAction = unauthenticatedAction;
    this.authenticatedSelector = authenticatedSelector;
    this.cancelledSelector = cancelledSelector;
    this.authPromise = null;
    this.handleRejected = this.handleRejected.bind(this);
    this.authenticate = this.authenticate.bind(this);
  }

  _createClass(AuthInterceptor, [{
    key: "authenticate",
    value: function authenticate() {
      var _this = this;

      this.store.dispatch(this.unauthenticatedAction());

      if (this.authenticatedSelector(this.store.getState()) || this.cancelledSelector(this.store.getState())) {
        console.error('AuthInterceptor found invalid state when handling unauthenticated ' + 'response. The selectors given (authenticated and cancelled) should ' + 'both return false initially and then return true once the user has ' + 'successfully authenticated or cancelled respectively.');
        return Promise.reject();
      }

      return new Promise(function (resolve, reject) {
        var unsub = _this.store.subscribe(function () {
          if (_this.authenticatedSelector(_this.store.getState())) {
            unsub();
            resolve();
          } else if (_this.cancelledSelector && _this.cancelledSelector(_this.store.getState())) {
            unsub();
            reject();
          }
        });
      });
    }
  }, {
    key: "handleRejected",
    value: function handleRejected(error) {
      var _this2 = this;

      if (error.response && error.response.status === 401 && !error.response.config.__bypassAuthInterceptor) {
        if (!this.authPromise) {
          this.authPromise = this.authenticate();
          this.authPromise["finally"](function () {
            _this2.authPromise = null;
          });
        }

        return new Promise(function (resolve, reject) {
          _this2.authPromise.then(function () {
            axios(error.response.config).then(resolve)["catch"](reject);
          })["catch"](function () {
            reject(error);
          });
        });
      } else {
        return Promise.reject(error);
      }
    }
  }]);

  return AuthInterceptor;
}();

export { AuthInterceptor as default };